import { createReducer } from '@reduxjs/toolkit';
import { addBuilderStateCase } from '../../Global/ComponentState/ComponentStateReducer';
import MediaDeviceMenuActions from './MediaDeviceMenuActions';
import { MediaDeviceMenuState } from './MediaDeviceMenuState';

const initialState: MediaDeviceMenuState = {
  state: { current: 'data' },
  availableMediaDevices: []
};
export const mediaDeviceMenuReducer = createReducer<MediaDeviceMenuState>(initialState, (builder) => {
  addBuilderStateCase(builder, 'MEDIA_DEVICE_MENU');
  builder.addCase(MediaDeviceMenuActions.setSelectedMediaDevice, (state, action) => ({
    ...state,
    selectedMediaDevice: action.payload
  }));
  builder.addCase(MediaDeviceMenuActions.setAvailableMediaDevices, (state, action) => ({
    ...state,
    availableMediaDevices: action.payload
  }));
});
